import {
    Center,
    Stack,
    Text,
    Box,
    Group,
    Paper,
    ThemeIcon,
    Title,
    Anchor,
} from '@mantine/core';
import { BookwellLogo } from 'src/components/ui/logos/BookwellLogo';
import VenueSignUpForm from 'src/components/auth/VenueSignUpForm';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Icons } from 'src/components/ui/Icons';
import { Link } from 'react-router-dom';

export default function VenueSignUp() {

    return (
        <>
            <Paper shadow="md" bg="white" w={{ base: '100%', md: 900 }}>

                <Box

                    style={{
                        backgroundImage: [
                            'radial-gradient(900px circle at 72% 38%, rgba(73, 164, 255, 0.26) 0%, transparent 58%)',
                                'radial-gradient(760px circle at 22% 72%, rgba(24, 233, 199, 0.18) 0%, transparent 60%)',
                                'radial-gradient(680px circle at 55% 108%, rgba(10, 112, 255, 0.14) 0%, transparent 66%)',
                                'radial-gradient(520px circle at 88% 16%, rgba(141, 184, 255, 0.16) 0%, transparent 62%)',
                                'linear-gradient(150deg, #02050d 0%, #06142a 44%, #0b2040 72%, #0f2b4f 100%)',
                        ].join(', '),
                    }}
                >
                    <Group p="md" px="xl">

                        <BookwellLogo height="100" />

                        <Stack gap="xl">

                            <Group gap="sm" align="center">
                                <ThemeIcon size={40} radius="md" variant="filled" color="dark" styles={{ root: { backgroundColor: 'rgba(255,255,255,0.14)' } }}>
                                    <Icon icon={Icons.venue} width={26} />
                                </ThemeIcon>
                                <Box>
                                    <Title order={2} size={30} fw={900} style={{ lineHeight: 1.05 }} c="white">
                                        Venue account
                                    </Title>
                                    <Text c="white" size="sm">
                                        For clubs, bars, hotels, restaurants, event spaces, and any business that takes bookings.
                                    </Text>
                                </Box>
                            </Group>

                        </Stack>

                    </Group>

                </Box>

                <Stack gap={0}>


                    <VenueSignUpForm />


                </Stack>
            </Paper>
            <Center mt="xl">
                <Stack justify="center" align="center">
                    <Text size="sm">
                        Already have an account?{' '}
                        <Anchor component={Link} to="/sign-in" fw={600}>
                            Sign in
                        </Anchor>
                    </Text>
                    <Text size="xs" c="dimmed">
                        © 2026 Rockwell. All rights reserved.
                    </Text>
                </Stack>
            </Center>
        </>
    );
}
